import type { CityConfig } from "../city-template/types";

export const booneConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Iowa HHS Vital Records", href: "https://hhs.iowa.gov/vital-records", description: "Official Iowa vital records office in Des Moines" },
    { label: "Marriage Licenses — Boone County Recorder", href: "https://www.boonecounty.iowa.gov", description: "Boone County Recorder — marriage license issuance" },
    { label: "Divorce Records — Boone County Clerk of Court", href: "https://www.iowacourts.gov/", description: "Boone County Clerk of Court — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Iowa HHS for online vital record orders" },
  ],
  city: "Boone",
  state: "Iowa",
  stateAbbr: "IA",
  slug: "boone",
  route: "/cities/boone",
  title: "Emergency Passport Boone, IA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Boone, IA — as fast as 24 hours. Serving Boone County and the Des Moines River Valley. A+ BBB rated registered State Dept. courier serving the Boone & Scenic Valley Railroad region. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Boone, IA",
  heroSubtitle: "Des Moines metro business trip to Toronto with two weeks notice? Family vacation to Europe and your passport expired? Pufferbilly Days parade trip and you need documents fast? We help Boone residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Boone%20Iowa%20small%20Midwestern%20city%20Boone%20and%20Scenic%20Valley%20Railroad%20historic%20train%20depot%20downtown%20main%20street%20brick%20buildings%20surrounded%20by%20cornfields%20and%20Ledges%20State%20Park%20wooded%20bluffs%20golden%20hour%20warm%20sunset%20light%20professional%20drone%20photography%20soft%20natural%20tones&width=1800&height=700&seq=boone-ia-hero-2026&orientation=landscape",
  heroImageAlt: "Boone Iowa with Boone & Scenic Valley Railroad and Ledges State Park at golden hour",
  geoPosition: "42.0597;-93.8802",
  geoPlacename: "Boone, Iowa",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B. Wells Drive, 9th Floor, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 340 miles east of Boone via I-80/I-88",
  },
  nearbyCitiesZips: [
    { name: "Boone", zips: "50036" },
    { name: "Ames", zips: "50010–50014" },
    { name: "Ogden", zips: "50212" },
    { name: "Madrid", zips: "50156" },
    { name: "Story City", zips: "50248" },
    { name: "Jefferson", zips: "50129" },
    { name: "Perry", zips: "50220" },
    { name: "Webster City", zips: "50595" },
    { name: "Fort Dodge", zips: "50501" },
    { name: "Nevada", zips: "50201" },
    { name: "Huxley", zips: "50124" },
    { name: "Ankeny", zips: "50021, 50023" },
    { name: "Des Moines", zips: "50301–50399" },
    { name: "Carroll", zips: "51401" },
    { name: "Marshalltown", zips: "50158" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Central Iowa departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Boone County Coverage", desc: "Serving Boone, Ames, Ogden, Madrid and the Des Moines River Valley" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Ames, IA", route: "/cities/ames" },
    { name: "Fast passport renewal in Des Moines, IA", route: "/cities/des-moines" },
    { name: "Emergency passport help in Fort Dodge, IA", route: "/cities/fort-dodge" },
    { name: "Urgent passport services in Ankeny, IA", route: "/cities/ankeny" },
    { name: "Same-day passport help in Omaha, NE", route: "/cities/omaha" },
    { name: "Passport courier services in Chicago, IL", route: "/cities/chicago" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Boone remotely via secure courier. We do not have a walk-in office in Boone — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Boone County and Central Iowa.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of Boone County and the Des Moines River Valley including Story, Greene, and Hamilton counties",
  serviceAreaIntro: "From the historic railroad yards and the Boone & Scenic Valley Railroad depot to the wooded bluffs of Ledges State Park, from the charming main streets of Ogden and Madrid to the college town of Ames, from the farm communities of Story City and Nevada to the county seat of Jefferson — Fast Passport Center serves the entire Boone County and Central Iowa region. We regularly help travelers from the Des Moines River Valley and beyond get their passports fast without the 340-mile drive to Chicago.",
  nearbyCitiesIntro: "We serve all Boone neighborhoods and the surrounding Central Iowa area including Ames, Ogden, Madrid, Story City, Jefferson, Perry, Webster City, Fort Dodge, Nevada, Huxley, Ankeny, and Des Moines. If you are anywhere in Boone County, Story County, or the Des Moines River Valley, we have you covered.",
  howItWorksIntro: "Most Boone travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Boone travelers often face a 5.5-hour drive to the nearest regional passport agency in Chicago. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Boone and Boone County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Boone? Here are the most common ones we hear from Central Iowa travelers.",
  statePageRoute: "/states/iowa",
  statePageName: "Iowa",
  dmvWebsite: "https://iowadot.gov/mvd",
  dmvLabel: "Iowa DOT — Motor Vehicle Division",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Boone travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Derek M.",
      location: "Boone, IA",
      rating: 5,
      text: "My passport expired right before our trip to Ireland. Fast Passport Center had my renewal in 30 hours. Never left Boone. Saved our family trip to Dublin.",
      service: "Passport Renewal",
    },
    {
      name: "Laura S.",
      location: "Ames, IA",
      rating: 5,
      text: "ISU study abroad trip to Germany — lost my passport 3 days before departure. Fast Passport Center had a replacement in 26 hours. Absolutely saved my semester.",
      service: "Lost Passport",
    },
    {
      name: "Tim R.",
      location: "Madrid, IA",
      rating: 5,
      text: "First-time passport for our family trip to Canada. Fast Passport Center walked us through every form. Got all 4 passports in 5 days. Incredible service.",
      service: "New Passport",
    },

  ],
  facilities: [
    {
      id: "boone-1",
      name: "Boone Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "815 Story St",
      city: "Boone",
      state: "IA",
      zip: "50036",
      phone: "(515) 432-2461",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Boone",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Boone facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "boone-2",
      name: "Boone County Recorder",
      type: "County Recorder Passport Acceptance",
      address: "201 State St",
      city: "Boone",
      state: "IA",
      zip: "50036",
      phone: "(515) 433-0512",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown Boone Courthouse",
      website: "https://www.boonecounty.iowa.gov",
      websiteLabel: "Boone County Recorder",
      notes: "Accepts passport applications. Good alternative to post office. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "boone-3",
      name: "Ames Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "525 Kellogg Ave",
      city: "Ames",
      state: "IA",
      zip: "50010",
      phone: "(515) 232-3215",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles east of Boone",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Large facility serving Story County. Full passport services available. Convenient for ISU travelers.",
      icon: "ri-mail-line",
    },
    {
      id: "boone-4",
      name: "Story County Recorder",
      type: "County Recorder Passport Acceptance",
      address: "900 6th St",
      city: "Nevada",
      state: "IA",
      zip: "50201",
      phone: "(515) 382-7230",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "20 miles east of Boone",
      website: "https://www.storycountyiowa.gov",
      websiteLabel: "Story County Recorder",
      notes: "Serves Story County with extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "boone-5",
      name: "Fort Dodge Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "205 S 8th St",
      city: "Fort Dodge",
      state: "IA",
      zip: "50501",
      phone: "(515) 576-2176",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "35 miles north of Boone",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Regional facility serving Webster County. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5.5 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Courier Service", agency: "Not available — self-transport only", fpc: "Registered courier hand-delivers documents" },
    { feature: "Photo Services", agency: "Not available at agency — must bring own", fpc: "Photo review and guidance included" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Boone photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Boone County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Boone applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Central Iowa families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Boone travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Boone." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Boone address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Boone before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Boone for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5.5-hour drive to Chicago." },
    { q: "How fast can I renew my passport in Boone?", a: "Fast Passport Center offers fast passport renewal in Boone in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Boone?", a: "The nearest regional passport agency to Boone is the Chicago Passport Agency, approximately 340 miles east via I-80/I-88. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Boone without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Boone?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 5.5 hours from Boone — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Boone County and Central Iowa residents." },
    { q: "Do you serve the entire Boone County region?", a: "Absolutely. Fast Passport Center serves the entire Boone County and Central Iowa region including Boone, Ogden, Madrid, Ames, Story City, Jefferson, Perry, and surrounding areas. Our courier service works seamlessly from any address in Boone, Story, Greene, or Hamilton counties." },
    { q: "Can I expedite a child passport in Boone?", a: "Yes. Fast Passport Center expedites child passports in Boone for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Central Iowa families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Boone with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Boone", address: "1303 SE Marshall St, Boone, IA 50036", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "Walgreens — Ames", address: "620 Lincoln Way, Ames, IA 50010", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Ames", address: "525 Kellogg Ave, Ames, IA 50010", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walmart Supercenter — Ames", address: "534 S Duff Ave, Ames, IA 50010", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
  ],
  dmvLocations: [
    {
      name: "Iowa DOT — Boone",
      address: "212 S Linn St, Boone, IA 50036",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services at the Boone County Courthouse. Appointment recommended.",
      featured: true,
    },
    {
      name: "Iowa DOT — Ames",
      address: "2525 University Blvd, Ames, IA 50010",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Full service location. REAL ID available. Appointment recommended.",
      featured: false,
    },
    {
      name: "Iowa DOT — Fort Dodge",
      address: "1115 S 17th St, Fort Dodge, IA 50501",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Webster County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "AMW",
      name: "Ames Municipal Airport",
      distance: "15 miles east of Boone",
      address: "2501 S Airport Rd, Ames, IA 50010",
      note: "General aviation airport serving Story County. About 20 minutes from Boone.",
      flightUrl: "https://www.cityofames.org/government/departments-divisions/airport",
      flightLabel: "AMW Airport",
      featured: true,
    },
    {
      code: "DSM",
      name: "Des Moines International Airport",
      distance: "50 miles south of Boone",
      address: "5800 Fleur Dr, Des Moines, IA 50321",
      note: "Major regional airport with direct flights nationwide. About 55 minutes from Boone.",
      flightUrl: "https://www.dsmairport.com/",
      flightLabel: "DSM Airport",
      featured: false,
    },
    {
      code: "FOD",
      name: "Fort Dodge Regional Airport",
      distance: "35 miles north of Boone",
      address: "1639 Nelson Ave, Fort Dodge, IA 50501",
      note: "Regional airport with direct flights to Chicago via United Express. About 45 minutes from Boone.",
      flightUrl: "https://www.fortdodgeiowa.org/airport",
      flightLabel: "FOD Airport",
      featured: false,
    },
  ],
};